import { css } from "lit-element";
export const kode4CssTheme = css `
    :root {
        --main-color: #444;
        --main-color-hover: #000;
        --main-color-filled: #fff;
        --main-color-filled-hover: #eee;
        --background-color: transparent;
        --background-color-filled: #444;
        --background-color-filled-hover: #000;

        --main-color-primary: #0670F9;
        --main-color-hover-primary: #055ECF;
        --main-color-filled-primary: #fff;
        --main-color-filled-hover-primary: #fff;
        --background-color-filled-primary: #0670F9;
        --background-color-filled-hover-primary: #055ECF;

        --main-color-secondary: #616A71;
        --main-color-hover-secondary: #50575D;
        --main-color-filled-secondary: #fff;
        --main-color-filled-hover-secondary: #fff;
        --background-color-filled-secondary: #616A71;
        --background-color-filled-hover-secondary: #50575D;

        --main-color-success: #289D44;
        --main-color-hover-success: #217C37;
        --main-color-filled-success: #fff;
        --main-color-filled-hover-success: #fff;
        --background-color-filled-success: #289D44;
        --background-color-filled-hover-success: #217C37;

        --main-color-danger: #D6313F;
        --main-color-hover-danger: #C0222F;
        --main-color-filled-danger: #fff;
        --main-color-filled-hover-danger: #fff;
        --background-color-filled-danger: #D6313F;
        --background-color-filled-hover-danger: #C0222F;

        --main-color-warning: #FEB92F;
        --main-color-hover-warning: #DB9E27;
        --main-color-filled-warning: #000;
        --main-color-filled-hover-warning: #000;
        --background-color-filled-warning: #FEB92F;
        --background-color-filled-hover-warning: #DB9E27;

        --main-color-info: #1B97AD;
        --main-color-hover-info: #17788A;
        --main-color-filled-info: #fff;
        --main-color-filled-hover-info: #fff;
        --background-color-filled-info: #1B97AD;
        --background-color-filled-hover-info: #17788A;
    }



    .kode4-text-primary {
        --main-color: var(--main-color-primary);
        --main-color-hover: var(--main-color-hover-primary);
    }

    .kode4-bg-primary {
        --main-color-filled: var(--main-color-filled-primary);
        --main-color-filled-hover: var(--main-color-filled-hover-primary);
        --background-color-filled: var(--background-color-filled-primary);
        --background-color-filled-hover: var(--background-color-filled-hover-primary);
    }

    .kode4-text-secondary {
        --main-color: var(--main-color-secondary);
        --main-color-hover: var(--main-color-hover-secondary);
    }

    .kode4-bg-secondary {
        --main-color-filled: var(--main-color-filled-secondary);
        --main-color-filled-hover: var(--main-color-filled-hover-secondary);
        --background-color-filled: var(--background-color-filled-secondary);
        --background-color-filled-hover: var(--background-color-filled-hover-secondary);
    }

    .kode4-text-success {
        --main-color: var(--main-color-success);
        --main-color-hover: var(--main-color-hover-success);
    }

    .kode4-bg-success {
        --main-color-filled: var(--main-color-filled-success);
        --main-color-filled-hover: var(--main-color-filled-hover-success);
        --background-color-filled: var(--background-color-filled-success);
        --background-color-filled-hover: var(--background-color-filled-hover-success);
    }

    .kode4-text-danger {
        --main-color: var(--main-color-danger);
        --main-color-hover: var(--main-color-hover-danger);
    }

    .kode4-bg-danger {
        --main-color-filled: var(--main-color-filled-danger);
        --main-color-filled-hover: var(--main-color-filled-hover-danger);
        --background-color-filled: var(--background-color-filled-danger);
        --background-color-filled-hover: var(--background-color-filled-hover-danger);
    }

    .kode4-text-warning {
        --main-color: var(--main-color-warning);
        --main-color-hover: var(--main-color-hover-warning);
    }

    .kode4-bg-warning {
        --main-color-filled: var(--main-color-filled-warning);
        --main-color-filled-hover: var(--main-color-filled-hover-warning);
        --background-color-filled: var(--background-color-filled-warning);
        --background-color-filled-hover: var(--background-color-filled-hover-warning);
    }

    .kode4-text-info {
        --main-color: var(--main-color-info);
        --main-color-hover: var(--main-color-hover-info);
    }

    .kode4-bg-info {
        --main-color-filled: var(--main-color-filled-info);
        --main-color-filled-hover: var(--main-color-filled-hover-info);
        --background-color-filled: var(--background-color-filled-info);
        --background-color-filled-hover: var(--background-color-filled-hover-info);
    }

    /*
    .kode4-text-secondary {
        --main-color: #616A71;
        --main-color-hover: #50575D;
    }

    .kode4-bg-secondary {
        --main-color-filled: #fff;
        --main-color-filled-hover: #fff;
        --background-color-filled: #616A71;
        --background-color-filled-hover: #50575D;
    }

    .kode4-text-success {
        --main-color: #289D44;
        --main-color-hover: #217C37;
    }

    .kode4-bg-success {
        --main-color-filled: #fff;
        --main-color-filled-hover: #fff;
        --background-color-filled: #289D44;
        --background-color-filled-hover: #217C37;
    }

    .kode4-text-danger {
        --main-color: #D6313F;
        --main-color-hover: #C02y22F;
    }

    .kode4-bg-danger {
        --main-color-filled: #fff;
        --main-color-filled-hover: #fff;
        --background-color-filled: #D6313F;
        --background-color-filled-hover: #C0222F;
    }

    .kode4-text-warning {
        --main-color: #FEB92F;
        --main-color-hover: #DB9E27;
    }

    .kode4-bg-warning {
        --main-color-filled: #000;
        --main-color-filled-hover: #000;
        --background-color-filled: #FEB92F;
        --background-color-filled-hover: #DB9E27;
    }

    .kode4-text-info {
        --main-color: #1B97AD;
        --main-color-hover: #17788A;
    }

    .kode4-bg-info {
        --main-color-filled: #fff;
        --main-color-filled-hover: #fff;
        --background-color-filled: #1B97AD;
        --background-color-filled-hover: #17788A;
    }
    */


    .kode4-text {
        color: var(--main-color);
    }

    a.kode4-text:hover,
    .kode4-text-hover:hover {
        color: var(--main-color-hover);
    }

    .kode4-bg {
        color: var(--main-color-filled);
        background-color: var(--background-color-filled);
    }

    a.kode4-bg:hover,
    .kode4-bg-hover:hover {
        color: var(--main-color-filled);
        background-color: var(--background-color-filled);
    }

    .kode4-alert {
        padding: 10px;
        color: var(--main-color-filled);
        background-color: var(--background-color-filled);
    }

    a.kode4-alert:hover,
    .kode4-alert-hover:hover {
        color: var(--main-color-filled-hover);
        background-color: var(--background-color-filled-hover);
    }
`;
//# sourceMappingURL=kode4-css-theme.js.map